






































































































































































import {
  computed,
  defineComponent,
  ref,
  watch,
  getCurrentInstance
} from "@vue/composition-api";
import OccPanel from "@/components/Atoms/OccPanel/index.vue";
import OccAccordion from "@/components/Atoms/OccAccordion/OccAccordion.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import OccTooltip from "@/components/Atoms/OccTooltip/OccTooltip.vue";
import { useOccNavigation, MenuConfig } from "@/helpers/hooks/useOccNavigation";
import { occPrimary } from "@/assets/styles/vars-for-script.scss";
import { RouterLocation } from "@/helpers/router-helper";
import { sendGaEvent } from "@/helpers/ga-helper";
import ContractPanelWrapper from "@/components/Pages/Scout/elements/ContractPanelWrapper/index.vue";
import { useRouter } from "@/router";
// import { useRoute, useRouter } from "@/router"; // TODO: vue-router4移行時に書き換える
const DRAWER_WIDTHS = {
  hide: 0,
  close: 32,
  open: 220
} as const;
export default defineComponent({
  name: "NavigationDrawer",
  components: {
    ContractPanelWrapper,
    OccPanel,
    OccAccordion,
    OccHeading,
    OccButton,
    OccTooltip
  },
  setup() {
    const { menuConfigs } = useOccNavigation();
    const instance = getCurrentInstance();
    const router = useRouter();
    // const route = useRoute(); // TODO: vue-router4移行時に書き換える
    const hoveredMenuIndex = ref<number>();
    // サイドメニューをクリックしたときの親メニューを示す
    const selectedMenu = ref<MenuConfig | undefined>();
    const expandAreaWidth = ref<number>(DRAWER_WIDTHS["hide"]);
    const isOpenExpandArea = ref<boolean>(false);
    const showExpandAreaContent = ref<boolean>(false);
    // ブラウザリロード時にアクティブなメニューを表示するために必要
    const activeMenu = computed<MenuConfig | undefined>(() => {
      return menuConfigs.value.find(menu => {
        if (menu.subMenus?.length) {
          return menu.subMenus?.some(subMenu => {
            if (subMenu.subMenus?.length) {
              return subMenu.subMenus?.some(nestedSubMenu => {
                return nestedSubMenu.to && checkActiveRoute(nestedSubMenu.to);
              });
            } else {
              return subMenu.to && checkActiveRoute(subMenu.to);
            }
          });
        } else {
          return menu.to && checkActiveRoute(menu.to);
        }
      });
    });

    const targetMenu = ref<MenuConfig | undefined>();
    const displayMenu = computed<MenuConfig | undefined>(() => {
      return selectedMenu.value || targetMenu.value;
    });
    const showExpandArea = computed<boolean>(() => {
      return !!displayMenu.value?.subMenus;
    });
    const categoryStyle = computed(() => {
      const style = {
        height: "100%",
        top: "0",
        transform: "translateX(0%)",
        width: "60px"
      };
      return style;
    });
    const subMenuStyle = computed(() => {
      const style = {
        height: "100%",
        top: "0",
        transform: "translateX(0%)",
        width: `${expandAreaWidth.value}px`,
        transition: "all 0.2s ease-in-out"
      };
      return style;
    });
    const checkActiveRoute = (location?: RouterLocation): boolean => {
      // TODO: vue-router3のhooksではrouteの変更を検知できないため、instance経由のrouteからアクセスする
      // vue-router4のhooksではrouteの変更を検知できるので、バージョンアップ時に書き換える。
      // https://router.vuejs.org/guide/advanced/composition-api.html#Accessing-the-Router-and-current-Route-inside-setup
      const route = instance?.proxy.$root.$route; // TODO: vue-router4移行時に削除してuseRouteで生成したrouteにアクセスさせる
      if (!route) return false;

      const noMatchedPath = !route.matched.length;
      if (!location || noMatchedPath) {
        return false;
      }
      const resolvedHref = router.resolve(location).href;
      return resolvedHref === route.path;
    };
    const onClickMenu = (menuIndex: number) => {
      targetMenu.value = menuConfigs.value[menuIndex];
      const hasSubMenu = targetMenu.value.subMenus?.length;
      const isActiveMenu = targetMenu.value.name === selectedMenu.value?.name;
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `サイドメニュー_${targetMenu.value.name}`
        });
      }
      if (!hasSubMenu && targetMenu.value.to) {
        selectedMenu.value = targetMenu.value;
        router.push(targetMenu.value.to).catch(err => err);
        hideExpandArea();
      } else {
        if (!isActiveMenu) {
          selectedMenu.value = targetMenu.value;
        }
        openExpandArea();
      }
    };
    const onClickSubMenu = (
      subMenuIndex: number,
      nestedSubMenuIndex?: number
    ) => {
      if (!displayMenu.value) return;

      const targetSubMenu = displayMenu.value?.subMenus?.[subMenuIndex];
      if (!targetSubMenu) {
        return;
      }

      if (nestedSubMenuIndex === undefined) {
        if (!targetSubMenu.subMenus) {
          if (instance) {
            sendGaEvent(instance.proxy, {
              gaEventCategory: `サイドメニュー_${displayMenu.value.name}_${targetSubMenu.name}`
            });
          }
        }
        if (targetSubMenu.to) {
          router.push(targetSubMenu.to).catch(err => err);
        }
      } else {
        const nestedSubMenu = targetSubMenu.subMenus?.[nestedSubMenuIndex];
        if (instance) {
          sendGaEvent(instance.proxy, {
            gaEventCategory: `サイドメニュー_${displayMenu.value.name}_${targetSubMenu.name}_${nestedSubMenu?.name}`
          });
        }
        if (nestedSubMenu?.to) {
          router.push(nestedSubMenu.to).catch(err => err);
        }
      }
    };
    const openExpandArea = () => {
      isOpenExpandArea.value = true;
      expandAreaWidth.value = DRAWER_WIDTHS["open"];
      // NOTE: ExpandArea が開くアニメーションが終わってからコンテンツを表示
      setTimeout(() => {
        showExpandAreaContent.value = true;
      }, 200);
    };
    const closeExpandArea = () => {
      isOpenExpandArea.value = false;
      showExpandAreaContent.value = false;
      expandAreaWidth.value = DRAWER_WIDTHS["close"];
      selectedMenu.value = undefined;
    };
    const hideExpandArea = () => {
      isOpenExpandArea.value = false;
      showExpandAreaContent.value = false;
      expandAreaWidth.value = DRAWER_WIDTHS["hide"];
    };
    const toggleExpandArea = () => {
      if (isOpenExpandArea.value) {
        const hasSubMenu = selectedMenu.value?.subMenus?.length;
        if (hasSubMenu) {
          closeExpandArea();
        } else {
          hideExpandArea();
        }
      } else {
        openExpandArea();
      }
    };
    watch(
      () => showExpandArea.value,
      currentShowSubMenu => {
        if (currentShowSubMenu && expandAreaWidth.value === 0) {
          expandAreaWidth.value = DRAWER_WIDTHS["close"];
        }
      }
    );
    watch(
      () => displayMenu.value,
      currentDisplayMenu => {
        if (!currentDisplayMenu) {
          hideExpandArea();
        }
      }
    );
    watch(
      () => activeMenu.value,
      (currentActiveMenu, prevActiveMenu) => {
        if (currentActiveMenu?.name !== prevActiveMenu?.name) {
          selectedMenu.value = currentActiveMenu;
          if (
            currentActiveMenu?.subMenus &&
            currentActiveMenu?.subMenus.length
          ) {
            openExpandArea();
          } else {
            hideExpandArea();
          }
        }
      }
    );
    return {
      menuConfigs,
      hoveredMenuIndex,
      expandAreaWidth,
      activeMenu,
      displayMenu,
      selectedMenu,
      categoryStyle,
      subMenuStyle,
      isOpenExpandArea,
      showExpandAreaContent,
      showExpandArea,
      DRAWER_WIDTHS,
      checkActiveRoute,
      onClickMenu,
      onClickSubMenu,
      toggleExpandArea,
      occPrimary
    };
  }
});
